/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ActiveInputs */

const en_common_active = /** @type {(inputs: Common_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const de_common_active = /** @type {(inputs: Common_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

const fr_common_active = /** @type {(inputs: Common_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actif`)
};

const es_common_active = /** @type {(inputs: Common_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activo`)
};

const it_common_active = /** @type {(inputs: Common_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attivo`)
};

const nl_common_active = /** @type {(inputs: Common_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actief`)
};

const pl_common_active = /** @type {(inputs: Common_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktywny`)
};

const fi_common_active = /** @type {(inputs: Common_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiivinen`)
};

const da_common_active = /** @type {(inputs: Common_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

const sv_common_active = /** @type {(inputs: Common_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Common_ActiveInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_active = /** @type {((inputs?: Common_ActiveInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ActiveInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_active(inputs)
	if (locale === "fr") return fr_common_active(inputs)
	if (locale === "es") return es_common_active(inputs)
	if (locale === "it") return it_common_active(inputs)
	if (locale === "nl") return nl_common_active(inputs)
	if (locale === "pl") return pl_common_active(inputs)
	if (locale === "fi") return fi_common_active(inputs)
	if (locale === "da") return da_common_active(inputs)
	if (locale === "sv") return sv_common_active(inputs)
	return en_common_active(inputs)
});